import mobileDetection from './browser-detection-mobile';
import desktopDetection from './browser-detection-desktop';

const isMobile = () => !!mobileDetection();
const isDesktop = () => !mobileDetection();
const browser = () => {
  const mobile = mobileDetection();

  if (mobile) {
    return mobile;
  }

  return desktopDetection();
}; // TODO: add desktop detection as well

export { isMobile, isDesktop, browser };
export default { isMobile, isDesktop, browser };
